module.exports = __webpack_public_path__ + "img/avatar7.2bad3b7c.png";